import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useNotificationListQuery, useNotificationStatusMutation } from '../../service/apiSlices/accessApiService';
import { nullUndefinedEmptyCheck } from '../../utils/helper';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { toast } from 'react-toastify';
import { getRandomColor, TOASTER_CONFIGS } from '../../constants';

const NotificationComponent = () => {
    const { data: notificationData } = useNotificationListQuery([]);
    const [notificationStatusApi] = useNotificationStatusMutation();
    const backgroundColor = useMemo(() => getRandomColor(), [notificationData]);

    const handleNotificationSeen = (notificationId: any) => {
        notificationStatusApi(notificationId)
            .unwrap()
            .then((response) => {
                // console.log(response, 'asdjnad')
            })
            .catch((error) => {
                toast.error(error?.data?.message, TOASTER_CONFIGS);
            })
    }
    return (
        <>
            {notificationData?.result?.data?.new?.length > 0 || notificationData?.result?.data?.seen?.length > 0 ?
                <>
                    {notificationData?.result?.data?.new?.length > 0 &&
                        <>
                            <Typography variant='h6' sx={[{ px: 2, fontWeight: 700, py: 2 }]}>New</Typography>
                            {notificationData?.result?.data?.new?.map((notificationElement: any, index: any) => (
                                <>
                                    <Accordion onChange={(event: any, isExpanded: any) => {
                                        if (!isExpanded) {
                                            handleNotificationSeen(notificationElement.id)
                                        }
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            id={`notification-panel-${index}`}
                                        >
                                            <Stack direction='row' spacing={3} useFlexGap={true} alignItems='center'>

                                                {nullUndefinedEmptyCheck(notificationElement.image) ? (
                                                    <Avatar>
                                                        <Box component='img'
                                                            src={notificationElement.image ?? <ImageIcon />} />
                                                    </Avatar>
                                                ) : (
                                                    <Avatar sx={{ m: 1, bgcolor: backgroundColor }}>
                                                        {notificationElement.title?.charAt(0)}
                                                    </Avatar>
                                                )}
                                                <Box>
                                                    <Typography variant='h6'>{notificationElement.title}</Typography>
                                                    <Typography variant='caption'>{moment(new Date(notificationElement.created_on)).format('MMM  DD, YYYY')}</Typography>
                                                </Box>
                                            </Stack>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Stack direction='column'>
                                                <Typography
                                                    sx={{ display: 'inline', }}
                                                    component="span"
                                                    variant="body2"
                                                    color="text.primary"
                                                    className='notification-description'
                                                >
                                                    {notificationElement.description}
                                                </Typography>
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                </>
                            ))}
                        </>
                    }
                    {notificationData?.result?.data?.seen?.length > 0 &&
                        <>
                            <Typography variant='h6' sx={[{ px: 2, fontWeight: 700, py: 2 }]}>Seen</Typography>
                            {notificationData?.result?.data?.seen?.map((notificationElement: any, index: any) => (
                                <Accordion>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        id={`notification-panel-${index}`}
                                    >
                                        <Stack direction='row' spacing={3} useFlexGap={true} alignItems='center'>

                                            {nullUndefinedEmptyCheck(notificationElement?.image) ? (
                                                <Avatar>
                                                    <Box component='img'
                                                        src={notificationElement.image ?? <ImageIcon />} />
                                                </Avatar>
                                            ) : (
                                                <Avatar sx={{ m: 1, bgcolor: backgroundColor }}>
                                                    {notificationElement.title?.charAt(0)}
                                                </Avatar>
                                            )}
                                            <Box>
                                                <Typography variant='h6'>{notificationElement.title}</Typography>
                                                <Typography variant='caption'>{moment(new Date(notificationElement.created_on)).format('MMM  DD, YYYY')}</Typography>
                                            </Box>
                                        </Stack>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Stack direction='column'>
                                            <Typography
                                                sx={{ display: 'inline', }}
                                                component="span"
                                                variant="body2"
                                                color="text.primary"
                                                className='notification-description'
                                            >
                                                {notificationElement.description}
                                            </Typography>
                                        </Stack>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </>
                    }
                </> :
                <Typography variant='h6' sx={[{ px: 2, fontWeight: 700 }]} align='center'>No Notifications</Typography>
            }
        </>
    )
}

export default NotificationComponent;